export { countryData, countryList } from "./countries";
export type { CountryData } from "./countries";

export {
  computeLocaleWith,
  getBrowserLanguage,
  getBrowserLocale,
  getCoreTranslationsFor,
  getCountryDataFor,
  getCountryFromUrl,
  getRegionDataFor,
  getRegionFromUrl,
  standardizeLocale,
} from "./helpers";

export { default as getCustomerResources } from "./customerResources";
